import type {ReactNode} from 'react';
import {createLDReactProviderWithClient} from '@launchdarkly/react-sdk';
import {getLDClient} from '../launch-darkly';
import {LaunchDarklyIdentify} from './LaunchDarklyIdentify';

const client = getLDClient();

const LDProvider = client ? createLDReactProviderWithClient(client) : null;

export function LaunchDarklyProvider({children}: {children: ReactNode}) {
  if (!LDProvider) return <>{children}</>;
  return (
    <LDProvider>
      <LaunchDarklyIdentify />
      {children}
    </LDProvider>
  );
}
